import UserInfoDTO from '@src/adapters/dto/user/UserInfoDTO';
import useCachedList from '@src/cache/CachedList';
import useFindUsersActiveLazy from '@src/adapters/hooks/user/useFindActiveUsers';

const UserList = () => {
  return useCachedList<UserInfoDTO>('userInfoList', useFindUsersActiveLazy);
};

export default UserList;
